import React from "react";
import type { ChatBoxWindowInfo } from "../types";

/** @note This default value will not be used. */
export const ChatBoxWindowContext = React.createContext<ChatBoxWindowInfo>({
	id: "",
	width: 0,
	height: 0,
	x: 0,
	y: 0,
	name: "",
	mode: "normal",
	onChangeWindowMode: () => {},
});
